"use strict";
exports.__esModule = true;
exports.isValidCountryCode = void 0;
function isValidCountryCode(inputString) {
    return !!inputString && ['US', 'USA', 'United States', 'Canada'].includes(inputString);
}
exports.isValidCountryCode = isValidCountryCode;
